import { fromJS } from 'immutable';
const policiesInCaps = {
  cancellation: 'Cancellation',
  group: 'Group',
  freeOfCharge: 'Free of Charge',
  family: 'Family',
  child: 'Child',
  infant: 'Infant',
};
const editSupplierContract = (contractDetails, payload) => {
  const initialContractDetails = fromJS(contractDetails);
  switch (payload.updateType) {
    case 'SAVED_CHECKIN_AND_CHECKOUT':
      return {
        contractDetails: fromJS({
          checkIn: payload.data.checkIn,
          checkOut: payload.data.checkOut,
          earlyCheckIn: payload.data.earlyCheckInChecked ? payload.data.earlyCheckIn : undefined,
          earlyCheckInFee: payload.data.earlyCheckInChecked
            ? payload.data.earlyCheckInFee
            : undefined,
          earlyCheckInCostType: payload.data.earlyCheckInChecked
            ? payload.data.earlyCheckInCostType
            : undefined,
          earlyCheckInPercentageType: payload.data.earlyCheckInChecked
            ? payload.data.earlyCheckInPercentageType
            : undefined,
          lateCheckOut: payload.data.lateCheckOutChecked ? payload.data.lateCheckOut : undefined,
          lateCheckOutFee: payload.data.lateCheckOutChecked
            ? payload.data.lateCheckOutFee
            : undefined,
          lateCheckOutCostType: payload.data.lateCheckOutChecked
            ? payload.data.lateCheckOutCostType
            : undefined,
          lateCheckOutPercentageType: payload.data.lateCheckOutChecked
            ? payload.data.lateCheckOutPercentageType
            : undefined,
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== 'checkinout'),
        }),
        editHistory: {
          detail: 'Updated Check-in & Check-out information',
          contractId: payload.contractId,
        },
      };
    case 'SAVE_POLICY_ADD_EDIT':
      const updateCxl = (initialContractDetails.toJS().locationPolicy || []).some(
        policy => policy.policyType === payload.data.policyType,
      );
      return {
        contractDetails: fromJS({
          locationPolicy: initialContractDetails.get('locationPolicy'),
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== payload.data.policyType),
        }).update('locationPolicy', locationPolicy => {
          if (
            locationPolicy &&
            locationPolicy.every(policy => policy.get('policyType') !== payload.data.policyType)
          ) {
            return locationPolicy.push(fromJS(payload.data));
          }
          return locationPolicy.map(policy => {
            if (policy.get('policyType') === payload.data.policyType) {
              return policy.merge(fromJS(payload.data));
            }
            return policy;
          });
        }),
        editHistory: {
          detail: `${updateCxl ? 'Updated' : 'Added'} ${
            policiesInCaps[payload.data.policyType]
          } Policy Info`,
          contractId: payload.contractId,
        },
      };
    case 'DELETE_LOCATION_POLICY':
      return {
        contractDetails: fromJS({
          locationPolicy: initialContractDetails
            .get('locationPolicy')
            .filter(policy => policy.get('policyType') !== payload.data.policyType),
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== payload.data.policyType),
        }),
        editHistory: {
          detail: `Deleted ${policiesInCaps[payload.data.policyType]} Policy Info`,
          contractId: payload.contractId,
        },
      };
    case 'UPDATE_SUPPLIER_INFO_TERMS_NOTES':
      return {
        contractDetails: fromJS({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== payload.data.fieldName),
        }).setIn(['supplierInfo', payload.data.fieldName], payload.data.value),
        editHistory: { detail: 'Updated Terms and Notes', contractId: payload.contractId },
      };
    case 'UPDATE_MARKET_INFO':
      return {
        contractDetails: fromJS({
          supplierInfo: initialContractDetails.get('supplierInfo'),
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== 'marketInfo'),
        }).setIn(
          ['supplierInfo', payload.data.fieldName],
          payload.data.value,
        ),
        editHistory: { detail: 'Updated Market Information', contractId: payload.contractId },
      };
    case 'SAVE_BILLING_INFO_ADD_EDIT':
      return {
        contractDetails: fromJS({
          billingInformation: payload.data,
          sameAsCorporatePolicyNotes: !initialContractDetails
            .get('sameAsCorporatePolicyNotes') ? []
            : initialContractDetails
            .get('sameAsCorporatePolicyNotes')
            .filter(str => str !== payload.type),
        }),
        editHistory: { detail: 'Updated Billing Information', contractId: payload.contractId },
      };
    case 'SAVE_CONTRACT_PERIOD':
      // for workspace or template draft
      return {
        contractDetails: fromJS({
          startDate: payload.data.newStartDate,
          endDate: payload.data.newEndDate,
        }),
        editHistory: { detail: 'Update Contract Period', contractId: payload.contractId },
      };
    case 'SAVE_LOCATION_NAME':
      // only for buyer's dummy rate sheet
      return {
        contractDetails: fromJS({
          locationName: payload.data.newLocationName,
        }),
        editHistory: { detail: 'Update Location Name', contractId: payload.contractId },
      };
    default:
      return {
        contractDetails: initialContractDetails,
      };
  }
};

export default editSupplierContract;



// WEBPACK FOOTER //
// ./src/app/stores/contracting/contract-activities-products/edit-contract-details.js